module.exports = __webpack_public_path__ + "media/images/farmers-1fd42bcd41b1aad72fa1a84cf9150fe5.jpg";